<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-container">
        <SearchInput @update-search-value="filterEstimations" />
        <Sort :options="sortOptions" @action="filterEstimations" />
        <button
          type="button"
          class="button button--filter"
          :class="{ 'filter--active': !isList }"
          @click="setList(false)"
        >
          <i class="fas fa-th-large"></i>
        </button>
        <button
          type="button"
          class="button button--filter"
          :class="{ 'filter--active': isList }"
          @click="setList(true)"
        >
          <i class="fas fa-bars"></i>
        </button>
      </div>

      <div class="list-container" v-if="isList">
        <List :headers="headers">
          <tr v-for="(item, i) in estimations" :key="i" class="list__line">
            <td>{{ item.client.firstName }} {{ item.client.lastName }}</td>
            <td>{{ prettyFullDate(item.createdAt) }}</td>
            <td>{{ toCurrency(item.estimationValue) }}</td>
            <td class="list__action">
              <button type="button" class="button button--valid">
                {{ $t('transaction.validation') }}
              </button>
            </td>
          </tr>
        </List>
      </div>

      <div class="card-container" v-if="!isList">
        <EstimationCard
          v-for="(estimation, i) in estimations"
          :key="i"
          :card="estimation"
          status="pending_transaction"
          @updateEstimation="filterEstimations"
          @fullView="fullView"
        />
      </div>

      <InfiniteScroll
        v-if="estimations.length < totalEstimations"
        @paginate="paginateEstimations"
      />
    </div>
  </div>
</template>

<script>
import { SearchInput, Sort, InfiniteScroll } from '../../components/filters';
import Navbar from '../../components/Navbar';
import EstimationCard from '../../components/EstimationCard';
import List from '../../components/List';
import { formatDate, formatNumber, EstimationComponent } from '../../mixins';
import { infiniteLoading } from '../../lib/customEvents';
import { mapGetters } from 'vuex';
import expertName from '@/mixins/expertName';

export default {
  components: {
    Navbar,
    EstimationCard,
    List,
    SearchInput,
    Sort,
    InfiniteScroll,
  },

  mixins: [formatDate, formatNumber, EstimationComponent],

  data() {
    return {
      isList: false,
      headers: ['fullname', 'reception-date', 'estimation', 'action'],
      sortOptions: [
        {
          title: 'filter.sort.newer',
          sortedElement: 'order[createdAt]',
          order: 'desc',
        },
        {
          title: 'filter.sort.older',
          sortedElement: 'order[createdAt]',
          order: 'asc',
        },
        {
          title: 'filter.sort.bigger_amount',
          sortedElement: 'order[estimationValue]',
          order: 'desc',
        },
        {
          title: 'filter.sort.lesser_amount',
          sortedElement: 'order[estimationValue]',
          order: 'asc',
        },
      ],
    };
  },

  async created() {
    const pendingTransactions = await this.fetchEstimations({
      status: 'pending_transaction',
    });

    if (!pendingTransactions || !pendingTransactions['hydra:member']) return;

    this.estimations = pendingTransactions['hydra:member'];

    if (!pendingTransactions['hydra:totalItems']) return;

    this.totalEstimations = pendingTransactions['hydra:totalItems'];
  },

  methods: {
    setList(value) {
      this.isList = value;
      this.$nextTick(() => document.dispatchEvent(infiniteLoading));
    },
  },
};
</script>
